import { func, number, oneOf, shape } from 'prop-types';
import React from 'react';
import { Button, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

import createModalToggle from '../generic/create-modal-toggle';
import { APPROVAL_TYPES, approvalConfirmationMessages } from './constants';

const ApprovalConfirmation = ({
  toggle,
  onSuccess,
  onRequest,
  opportunityId,
  data,
}) => {
  return (
    <>
      <ModalHeader toggle={toggle}>Request an approval</ModalHeader>
      <ModalBody>{approvalConfirmationMessages[data.type]}</ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          onClick={() => onRequest(opportunityId, data).then(onSuccess)}
        >
          Yes
        </Button>
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </>
  );
};

ApprovalConfirmation.propTypes = {
  toggle: func.isRequired,
  onSuccess: func.isRequired,
  onRequest: func.isRequired,
  opportunityId: number.isRequired,
  data: shape({
    type: oneOf(Object.values(APPROVAL_TYPES)).isRequired,
    quoteId: number,
  }).isRequired,
};

export default createModalToggle(
  'Request an approval',
  ApprovalConfirmation,
  { color: 'primary' },
  { size: 'md' },
);
